import {createContext, useContext} from "react";
import {Store} from "../store/Store";

export const StoreContext = createContext<Store>(new Store());
export const useStore = ():Store=>{
    return useContext(StoreContext)
}